export default function MarketingData() {
  return [
    {
      text: [
        {
          title: "What is LoanMatch Protector",
          paragraphs: ["With LoanMatch Protector, you can get the customized coverage you need at affordable prices. Because of the digital process, simplified application, and the decreasing coverage feature, this product is up to 30% more affordable when compared to other life insurance products."],
        }
      ],
      image: "/product-landing/loan/circle2.png"
    },
    {
      text: [
        {
          title: "Get Approved Instantly",
          paragraphs: ["With LoanMatch Protector, you will get an instant decision online right from your phone, tablet or computer. This is the most efficient way to purchase life insurance when compared to other options that can take weeks or months."],
        }
      ],
      image: "product-landing/loan/circle3.png",
    },
    {
      text: [
        {
          title: "Customized Coverage at the Best Price",
          paragraphs: ["With instant loan protection life insurance, you can get the customized coverage you need with the affordability of fully underwritten insurance without having to complete a medical exam. Similar level period life insurance can cost up to three times as much. You can start and finish your application online in minutes, with no interruptions."],
        }
      ],
      image: "/product-landing/loan/circle4.png"
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Americo/MarketingData.js